import Registry from './app/viewRegistry.js';
import HierarchyLevelsView from './app/components/hierarchy_fields/HierarchyLevelsView.jsx';
import StoresIndex from './app/views/content/stores/index.js';
import StoresShow from './app/views/content/stores/show.js';
import StoresExport from './app/views/content/stores/export.js';
import PaymentDevicesMove from './app/views/content/payment_devices/move.js';
import ImpactedClusterSettingsResources from './app/views/content/node_groups/impacted_cluster_settings_resources.js';
import StoresNew from './app/views/content/stores/new.js';
import PaymentDevicesHistory from './app/views/content/payment_devices/history.jsx';
import PropertiesShow from './app/views/content/properties/show.js';
import ETLImports from './app/views/content/imports/etl.js';
import ExportersJobs from './app/views/content/exporters_jobs/index.js';
import ExportersRestoreJobs from './app/views/content/exporters_restore_jobs/index.js';
import RoleForm from './app/views/content/roles/form.js';
import HashFormView from './app/views/content/hash/hash_form.js';
import GlobalIntegrations from './app/views/content/global_integrations/show.js';
import NodesExport from './app/views/content/nodes/export.js';
import OwnershipTransfers from './app/views/content/ownership_transfers/index.js';
import OwnershipTransfersShow from './app/views/content/ownership_transfers/show.js';
import RemoteJobsShow from './app/views/content/remote_jobs/show.js';
import RemoteJobs from './app/views/content/remote_jobs/index.js';
import RpmLogs from './app/views/content/rpm_logs/index.js';

module.exports = function () {
  const routes = new Navigo('/', false);

  routes.on('/hierarchy_fields', () => {
    Registry.load(
      HierarchyLevelsView,
      document.querySelector('#hierarchy-levels-view'),
    );
  });

  routes.on('/stores', () => Registry.load(StoresIndex));
  routes.on('/stores/new', () => Registry.load(StoresNew));
  routes.on('/stores/export', (params) => Registry.load(StoresExport, params));
  routes.on('/stores/:id', (params) => Registry.load(StoresShow, params));
  routes.on('/stores/:id/export', (params) =>
    Registry.load(StoresExport, params),
  );
  routes.on('/stores/:id/payment_devices/move_confirmation', () =>
    Registry.load(PaymentDevicesMove),
  );
  routes.on('/stores/:store/payment_devices/:id/history', (params) =>
    Registry.load(PaymentDevicesHistory, params),
  );
  routes.on('/properties/:id', () => Registry.load(PropertiesShow));
  routes.on('/etl_imports', () => Registry.load(ETLImports));
  routes.on('/exporters_jobs', () => Registry.load(ExportersJobs));
  routes.on('/exporters_restore_jobs', () =>
    Registry.load(ExportersRestoreJobs),
  );
  routes.on('/roles/new', () => Registry.load(RoleForm));
  routes.on('/roles/:id', () => Registry.load(RoleForm));
  routes.on('/node_groups/:id/impacted_cluster_settings_resources', () =>
    Registry.load(ImpactedClusterSettingsResources),
  );
  routes.on('/global_integrations', () => Registry.load(GlobalIntegrations));
  routes.on('/nodes/export', () => Registry.load(NodesExport));

  routes.on('/ownership_transfers', () => Registry.load(OwnershipTransfers));
  routes.on('/ownership_transfers/:id', () =>
    Registry.load(OwnershipTransfersShow),
  );

  routes.on('/remote_jobs', () => Registry.load(RemoteJobs));
  routes.on('/remote_jobs/:id', () => Registry.load(RemoteJobsShow));
  routes.on('/rpm_logs', () => Registry.load(RpmLogs));

  // Hash Form Routes
  const hashRoutes = [
    '/node_groups/:node_group/hash/:property_id',
    '/nodes/:hostname/hash/:property_id',
    '/servers/:hostname/hash/:property_id',
    '/customers/:customer/hash/:property_id',
  ];

  hashRoutes.forEach((route) => {
    routes.on(route, () => Registry.load(HashFormView));
  });

  return routes;
};
